import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { authGuard } from './core/guards/auth.guard';
import { NavbarComponent } from './features/navbar/navbar.component';
import { SidebarComponent } from './features/sidebar/sidebar.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, ToastModule, MessageModule,NavbarComponent,SidebarComponent,NgIf],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  showPrivateLayout: boolean = false;

  constructor(private readonly router: Router) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentRoute = this.router.routerState.snapshot.root.firstChild;
      if (currentRoute) {
        const routeCanActivate = currentRoute.routeConfig?.canActivate || [];
        this.showPrivateLayout = routeCanActivate.includes(authGuard);
      }
    });
  }
}
